import { useDisclosure } from "@/hooks";
import { getJwtToken } from "@/services/getJWT";
import { useUserStore } from "@/states/zustand/user";
import { Button, Modal } from "antd";
import { AiOutlineLogout } from "react-icons/ai";
import { useNavigate } from "react-router";

export function LogoutModal() {

    const [opened, { toggle }] = useDisclosure(false);
    const nav = useNavigate();

    const onLogout = () => {
        getJwtToken().removeJwtToken();
        useUserStore.getState().clearJwt();
        nav("/login", { replace: true });
        toggle();
    }

    return (
        <>
            <Button
                type="primary"
                danger
                onClick={toggle}
                icon={
                    <AiOutlineLogout />
                }
                size="large"
                className="!justify-start !rounded-none !min-h-10"
            >
                Logout
            </Button>
            <Modal
                open={opened}
                onCancel={toggle}
                onOk={onLogout}
                okText="‌ထွက်မည်"
                cancelText="မထွက်‌‌တော့ပါ"
                title="အကောင့်ထွက်ရန်"
                centered
                width={400}
                okButtonProps={{
                    danger: true,
                    type: "primary",
                    size: "large",
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                }}
                classNames={{
                    header: "[&>.ant-modal-title]:!text-lg"
                }}
            >
                <p
                    className="text-base my-4 text-neutral-500"
                >
                    သင်အကောင့်ထွက်လိုပါသလား? Logout လုပ်ပါက သင်၏ အချက်အလက်များကို ထိန်းသိမ်းမည်မဟုတ်ပါ။
                </p>
            </Modal>
        </>
    )
}
